/**
 * Every piece of UI that requires javascript should have its own
 * javascript file. Use this file as a template for structuring
 * all JS source files.
 *
 * {Document Title}
 * {Description}
 */

( function( window, $ ) {
	'use strict';
	var document = window.document;

    var categorySelector = {

        init: function() {
            $(document).on('change', '#page .category-selector', (function(e){

                var cat_slug = $('.category-selector option:selected').data('cat-slug');
                window.location = cat_slug;
                //$(document).trigger("_load_link", cat_slug);

            }));
        }

    };

    $(document).ready(function(){
        categorySelector.init();
    });

} )(window,jQuery);
